import { GridColumns } from 'shared/types';
import { useCallback, useMemo } from 'react';
import { removeUnimplementedFilters } from 'shared/utility/dataGrid';

export interface UseColumnsProps<T> {
    columnConfig: GridColumns<T>;
}

export function useColumns<T>({ columnConfig }: UseColumnsProps<T>) {
    const generateGridColumns = useCallback(() => {
        return removeUnimplementedFilters<T>(columnConfig);
    }, [columnConfig]);

    const columns = useMemo(() => generateGridColumns(), [generateGridColumns]);

    return columns;
}
